import { gql } from '@apollo/client';
import client from '../../util/GraphqlClient';

export const CART_SCHEMA = `
  uuid
  reference
  creditScore
  journeyType
  channelGroup
  offerType
  availableTopUp
  deliveryRequired
  activationDateRequired
  additionalAllowedOffers {
    number
    serviceGroup
  }
  amountVatIncluded {
    discountedUpFrontAmount
    oneOffAmount
    discountedOneOffAmount
    recurringAmount {
      amount
      discountedAmount
    }
  }
  offers {
    id
      depositAmountVatExcluded
      depositAmountVatIncluded
      modemCompatible
      prequal
      {
        prequalId       
      }
    portInInfo {
      portInReference
      msisdn
      portStartDateTime
    }
    appointment
    {
      at
      time
      type
    }
    discounts
    {
      billingType
        catalogCode
        discountItemType
        value
        description
    }
    addOns {
      description
      displayName
      id
      catalogCode
      itemGroup
      discounts
    {
      billingType
        catalogCode
        discountItemType
        value
        description
    }

      amountVatIncluded
      {
        recurringAmount
        {
          amount
          discountedAmount
        }
      }
    }
    activationFeeVatIncluded {
      oneOffAmount
      discountedOneOffAmount
      discountedUpFrontAmount
    }
    amountVatIncluded {
      recurringAmount {
        discountedAmount
        amount
      }
    }
    inclusiveEquipments {
      inclusiveEquipmentCatalogCode
      color
      colorCode
      description
      inventoryCode
      main
      manufacturer
      model
      type
    }
    equipments {
      type
      capacity
      color
      colorCode
      catalogCode 
      description
      id
      imei
      model
      inventoryCode
      simCardTypes
      manufacturer
      charge {
        catalogCode
      }
      amountVatIncluded {
        upFrontAmount
        discountedOneOffAmount
        discountedUpFrontAmount
        recurringAmount {
          amount
          discountedAmount
        }
      }
      addOn{
        description
        id
        catalogCode
        itemGroup
        amountVatIncluded
       {
         recurringAmount
         {
          amount
          discountedAmount
         }
       }
      }
    }
    baseOffer {
      broadbandTechnology
      description
      simOnly
      portIn
      catalogCode,
      catalogTariffPlanCode
      comment
      commitmentDuration
      serviceGroup
      minDownloadSpeed
      minUploadSpeed
      amountVatIncluded
        {
          recurringAmount
          {
            amount
            discountedAmount
            discountOccurrence

          }
        }
    }
    topUpAmount
  }
`;

const QUERIES = {
  GET_CARTS: gql`
    query getCart($reference: String!, $cartType: CartType) {
      getCart(reference: $reference,
        cartType: $cartType) {
        ${CART_SCHEMA}
      }
    }
  `,
  GET_PREPAY_CART_DETAILS: gql`
    query getCart($prospectUuid: String!) {
      cartDetails(prospectUuid: $prospectUuid) {
        numberOfProducts
      }
    }
  `,
  ADD_TOPUP: gql`
    mutation addTopUpValue($prospectUuid: String!, $cartOfferId: Int!, $topUpAmount: Int!) {
      addTopUpValue(prospectUuid: $prospectUuid, cartOfferId:$cartOfferId, topUpAmount:$topUpAmount) {
        ${CART_SCHEMA}
      }
    }
  `,
};

const getCarts = async ({ graphql, variables = {} }) => {
  const variable = { ...variables };
  if (variable?.token === 'true') {
    variable.token = '';
  }
  const { data } = await graphql.query({
    query: QUERIES.GET_CARTS,
    variables: variable,
  });
  return data;
};

export const getPrepayCarts = async ({ graphql, variables = {} }) => {
  const { data } = await graphql.query({
    query: QUERIES.GET_PREPAY_CART_DETAILS,
    variables,
  });
  return data.cartDetails;
};

export const addTopUpValue = async ({ graphql, variables = {} }) => {
  const { data } = await graphql.mutate({
    mutation: QUERIES.ADD_TOPUP,
    variables,
  });
  return data;
};

export const getCartAtServerSide = async ({ variables = {} }) => {
  try {
    const { data } = await client.query({
      query: QUERIES.GET_CARTS,
      variables,
    });
    return data;
  } catch (error) {
    console.error(error.graphQLErrors);
    return { error };
  }
};
export default getCarts;
